/* ============================================================
   I AM LUIGI — Custom UX & Brand Improvements
   La Stagione Calma preview • v9.0 • 2026-10-08
   Homepage-inhoud komt nu uit secties (ial-collection-feature,
   ial-category-tiles, ial-boetiek) in plaats van uit dit script.
   ============================================================ */

(function () {
  'use strict';

  /* ———— HELPERS ————————————————————————————————————— */
  function isHomepage() {
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  /* ———— SORT SOLD OUT ——————————————————————————————————— */
  function sortSoldOutToBottom() {
    var cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper, [data-product-card]');
    cards.forEach(function (card) {
      var badges = card.querySelectorAll('.badge--sold-out, [class*="sold-out"], [class*="soldout"]');
      if (badges.length > 0) {
        card.classList.add('ial--sold-out-card');
        var parent = card.parentElement;
        if (parent) parent.appendChild(card);
      }
    });
  }

  /* ———— FIX COLOUR LABEL ————————————————————————————————— */
  function fixColourLabel() {
    document.querySelectorAll('label, legend, .product-form__label, .product-form__input label').forEach(function (el) {
      if (/^(colour|color)$/i.test(el.textContent.trim())) {
        el.textContent = 'Kleur';
      }
    });
  }

  /* ———— BREADCRUMBS —————————————————————————————————————— */
  function initBreadcrumbs() {
    var path = window.location.pathname;
    var isProduct = path.indexOf('/products/') !== -1;
    var isCollection = path.indexOf('/collections/') !== -1;
    var isPage = path.indexOf('/pages/') !== -1;
    if (!isProduct && !isCollection && !isPage) return;

    var heading = document.querySelector('.product__title, h1.product-title, h1.title, .collection__title h1, .page__title');
    if (!heading) return;

    var crumb = document.createElement('nav');
    crumb.className = 'ial-breadcrumb';
    crumb.setAttribute('aria-label', 'Broodkruimelpad');

    var parts = [];
    parts.push('<a href="/">Home</a>');

    if (isProduct) {
      var collHandleMatch = document.referrer.match(/\/collections\/([^/?#]+)/);
      if (collHandleMatch) {
        var collHandle = collHandleMatch[1];
        var collLabel = collHandle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        parts.push('<a href="/collections/' + collHandle + '">' + collLabel + '</a>');
      } else {
        parts.push('<a href="/collections/all">Shop</a>');
      }
      parts.push('<span class="ial-breadcrumb__current">' + heading.textContent.trim() + '</span>');
    } else if (isCollection) {
      parts.push('<span class="ial-breadcrumb__current">' + (heading.textContent.trim() || 'Collectie') + '</span>');
    } else if (isPage) {
      parts.push('<span class="ial-breadcrumb__current">' + (heading.textContent.trim() || 'Pagina') + '</span>');
    }

    crumb.innerHTML = parts.join('<span class="ial-breadcrumb__sep">/</span>');
    heading.parentNode.insertBefore(crumb, heading);
  }

  /* ———— STICKY ATC BAR (mobile) —————————————————————————————— */
  function initStickyATC() {
    if (!isProductPage()) return;
    if (window.innerWidth > 768) return;

    var addBtn = document.querySelector('.product-form button[name="add"], .product-form button[type="submit"]');
    var productTitle = document.querySelector('.product__title, h1.product-title, .product__info-title');
    if (!addBtn) return;

    var bar = document.createElement('div');
    bar.id = 'ial-sticky-cart-bar';
    var titleText = productTitle ? productTitle.textContent.trim() : '';
    bar.innerHTML = '<span class="ial-sticky-title">' + titleText + '</span><button class="ial-sticky-btn">In winkelwagen</button>';
    document.body.appendChild(bar);

    bar.querySelector('.ial-sticky-btn').addEventListener('click', function () {
      addBtn.click();
    });

    var observer = new IntersectionObserver(function (entries) {
      bar.style.display = entries[0].isIntersecting ? 'none' : '';
    }, { threshold: 0.5 });
    observer.observe(addBtn);
  }

  /* ———— PRODUCT TRUST BLOCK ————————————————————————————————— */
  function initProductTrust() {
    if (!isProductPage()) return;
    var form = document.querySelector('.product-form, form[action*="/cart/add"]');
    if (!form) return;

    var block = document.createElement('div');
    block.className = 'ial-product-trust';
    block.innerHTML = [
      '<div class="ial-product-trust__item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg><span><strong>Gratis verzending</strong>Vanaf €100 in Nederland</span></div>',
      '<div class="ial-product-trust__item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg><span><strong>Passen in de boetiek</strong>Herenstraat 85A, Voorburg</span></div>',
      '<div class="ial-product-trust__item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span><strong>Zorgvuldig geselecteerd</strong>Premium kwaliteit, persoonlijke keuze</span></div>'
    ].join('');
    form.insertAdjacentElement('afterend', block);
  }

  /* ———— PRODUCT STORY BLOCK ————————————————————————————————— */
  function initProductStory() {
    if (!isProductPage()) return;
    setTimeout(function () {
      var trustBlock = document.querySelector('.ial-product-trust');
      if (!trustBlock) return;
      var story = document.createElement('div');
      story.className = 'ial-product-story';
      story.innerHTML = [
        '<p class="ial-product-story__label">I am Luigi</p>',
        '<p class="ial-product-story__text">Elk stuk in de boetiek kiezen we zelf uit, op pasvorm, materiaal en hoe het draagt. Twijfel je over je maat of over een combinatie, dan denken we graag met je mee, online of bij ons in de boetiek in Voorburg.</p>'
      ].join('');
      trustBlock.insertAdjacentElement('afterend', story);
    }, 250);
  }

  /* ———— NEWSLETTER POPUP (homepage only) ——————————————————————————— */
  function initNewsletterPopup() {
    if (!isHomepage()) return;
    var overlay = document.getElementById('ial-nl-popup-overlay');
    if (!overlay) return;
    try { if (localStorage.getItem('ial_nl_done')) return; } catch (e) {}

    var popup = document.getElementById('ial-nl-popup');
    var closeBtn = document.getElementById('ial-nl-popup-close');
    var skipBtn = document.getElementById('ial-nl-popup-skip');
    var emailInput = document.getElementById('ial-nl-popup-email');
    var body = document.getElementById('ial-nl-popup-body');
    var form = document.getElementById('ial-popup-nl-form');
    if (!popup || !form) return;

    function showPopup() {
      overlay.classList.add('ial--visible');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      overlay.classList.remove('ial--visible');
      document.body.style.overflow = '';
      try { localStorage.setItem('ial_nl_done', '1'); } catch (e) {}
    }

    setTimeout(showPopup, 6000);

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (skipBtn) skipBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return;

      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: 'contact[email]=' + encodeURIComponent(email) + '&contact[tags]=nieuwsbrief&form_type=customer&utf8=%E2%9C%93'
      }).then(function () {
        if (body) body.innerHTML = '<p class="ial-nl-popup__ok">✅ Bedankt! Je staat ingeschreven voor de nieuwsbrief van I am Luigi.</p>';
        try { localStorage.setItem('ial_nl_done', '1'); } catch (e) {}
        setTimeout(closePopup, 2800);
      }).catch(function () {
        if (body) body.innerHTML = '<p class="ial-nl-popup__ok">✅ Bedankt! Je bent ingeschreven.</p>';
        try { localStorage.setItem('ial_nl_done', '1'); } catch (e) {}
        setTimeout(closePopup, 2800);
      });
    });
  }

  /* ———— INIT ——————————————————————————————————————————————— */
  function init() {
    sortSoldOutToBottom();
    fixColourLabel();
    initBreadcrumbs();
    initStickyATC();
    initProductTrust();
    initProductStory();
    initNewsletterPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
